import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'mai',
    fullName: 'Maithili',
    nativeName: 'मैथिली',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "आर्गवोइड",
    landing_title: "किछु गजब आबि रहल अछि",
    landing_subtitle: "आर्गवॉइड एकटा ऐप आ गेम डेवलपमेंट स्टूडियो अछि । जुडल रहू, नव-नव बात जल्दिये आबि रहल अछि!",
    select_language: "भाषा चुनें",
    search_placeholder: "भाषा खोजें...",
    terms_title: "सेवा के शर्तें",
    policy_title: "गोपनीयता नीति",
    cookies_title: "कुकी नीति",
    terms_content: `
        <strong>1। शर्तों की स्वीकृति</strong><br>
        ArgVoid कें एक्सेस करय सं, इ सेवा कें शर्तक कें स्वीकार कैल जायत छै. यदि इ शर्तक पर सहमत नहि छै, त सेवा कें उपयोग नहि कैल जेबाक चाही.<br><br>

        <strong>2। प्लेटफार्म के उपयोग</strong><br>
        आर्गवॉइड आ ओकर एप्लीकेशन सूचनात्मक आ रचनात्मक उद्देश्यक कें लेल "जैना छै" उपलब्ध करायल गेल छै. सेवा कें उपयोग केवल कानूनी उद्देश्यक कें लेल करनाय आवश्यक छै.<br><br>

        <strong>3। निषिद्ध आचरण</strong><br>
        साइट कें कमजोरी कें दोहन करनाय, स्पैमिंग करनाय, या बुनियादी ढाँचा कें अनधिकृत पहुंच कें प्रयास करनाय सख्ती सं निषिद्ध छै.<br><br>

        <strong>4। अस्वीकरण</strong><br>
        प्लेटफॉर्म आ सेवाक मे कोनों समय बिना कोनों सूचना कें संशोधन कैल जा सकय छै. सेवा कें अपटाइम या उपलब्धता कें संबंध मे कोनों वारंटी नहि देल गेल छै.
    `,
    policy_content: `
        <strong>1। सूचना संग्रह</strong><br>
        प्लेटफॉर्म कें लेल अइ समय उपयोगकर्ता प्रमाणीकरण या खाता निर्माण कें आवश्यकता नहि छै. कोनों व्यक्तिगत पहचान करय वाला जानकारी (जैना नाम या ईमेल पता) सक्रिय रूप सं आगंतुक सं एकत्रित नहि कैल जायत छै.<br><br>

        <strong>2। उपयोग डेटा</strong><br>
        साइट ट्रैफिक कें समझय आ एप्लीकेशन मे सुधार कें लेल बेसिक, बेनामी विश्लेषणात्मकता एकत्र कैल जा सकय छै. इ डाटा व्यक्तिगत उपयोगकर्ता पहचान सं जुड़ल नहि छै.<br><br>

        <strong>3। तृतीय पक्ष सेवाएँ</strong><br>
        होस्टिंग आ एनालिटिक्स सेवाक कें लेल थर्ड पार्टी प्रदाताक कें उपयोग कैल जा सकय छै. इ संबंधित प्रदाताक कें गोपनीयता प्रथाक ओकर बुनियादी ढाँचा पर संसाधित अनाम डेटा कें नियंत्रित करयत छै.<br><br>

        <strong>4। डेटा सुरक्षा</strong><br>
        प्लेटफॉर्म के सुरक्षा के लेल उचित सुरक्षा उपाय लागू कएल गेल अछि. मुदा, इंटरनेट पर संचरणक कोनो तरीका पूर्ण रूप सं सुरक्षित नहिं अछि.<br><br>
    `,
    cookies_content: `
        <strong>1। कुकीज़ आ स्थानीय भंडारण की छै?</strong><br>
        कुकीज़ आ ब्राउज़र स्थानीय भंडारण छोट डाटा फाइल छै जे डिवाइस पर संग्रहीत कैल गेल छै जइ सं पूरा विजिट.<br><br> मे विन्यास वरीयताक कें याद राखल जा सकय

        <strong>2। उपयोग उद्देश्य</strong><br>
        ब्राउज़र LocalStorage कें उपयोग सख्ती सं विन्यास सेटिंग्स कें सहेजय कें लेल कैल जायत छै, जेना:<br>
        - भाषा वरीयता<br>
        - उपयोगकर्ता इंटरफेस विन्यास (जैसे, लेआउट या थीम सेटिंग्स)<br>
        - अस्थायी अनुप्रयोग cache<br><br>

        <strong>3। कोनो ट्रैकिंग</strong><br> नहि
        कुकीज़ आ स्थानीय भंडारण कें उपयोग विज्ञापन या तृतीय पक्ष ट्रैकिंग कें उद्देश्य सं नहि कैल जायत छै. सबटा संग्रहीत डाटा सख्ती सं प्लेटफॉर्म.<br><br> कें कोर कार्यक्षमता कें लेल छै

        <strong>4। नियंत्रण</strong><br>
        ब्राउज़र सेटिंग्स कें माध्यम सं ब्राउज़र डाटा कें कोनों समय साफ कैल जा सकय छै, जे कोनों स्थानीय विन्यास कें रीसेट करतय.
    `,
    cookie_consent_text: "हम वेबसाइट सही ढंग सं काज करय कें सुनिश्चित करय कें लेल बेसिक कुकीज़ कें उपयोग करय छी, जेना कि अहां कें सत्र कें सक्रिय रखनाय, अहां कें भाषा पसंद कें सहेजनाय, आ अन्य कस्टम विन्यास.",
    read_policy: "कुकी नीति पढ़ें",
    support_title: "समर्थन से संपर्क करें",
    support_subject_label: "विषय",
    support_message_label: "संदेश",
    support_submit_button: "संदेश भेजें",
    support_hint: "नोट: एहि सं संदेश भेजय लेल अहां के डिफ़ॉल्ट ईमेल एप्लीकेशन खुलत.",
    support_success_msg: "अपन ईमेल ऐप खोलैत...",
    support_error_msg: "संदेश पठेबामे विफल। कृपया बाद मे दोबारा प्रयास करू।",
    explorer_title: "एक्सप्लोरर",
    history_title: "इतिहास",
    animation_title: "एनीमेशन",
    config_title: "विन्यास",
    tool_mouse: "(Ctrl+M) चुनें।",
    tool_brush: "ब्रश (Ctrl+B) 1।",
    tool_brush_mode: "टॉगल मोड (ठोस/स्पष्ट) २.",
    tool_eraser: "इरेजर (Ctrl+E) 1।",
    tool_brush_size: "ब्रश साइज समायोजित करू",
    tool_bucket: "भरें (Ctrl+F) 1।",
    tool_eyedropper: "आईड्रॉपर",
    tool_grid: "ग्रिड (Ctrl+Shift+B) 1।",
    tool_rotate: "घुमाउ (Ctrl+Shift+R) 1।",
    tool_flip_h: "फ्लिप एच (Ctrl + शिफ्ट + एच) 1।",
    tool_flip_v: "फ्लिप वी (Ctrl + शिफ्ट + वी) 1।",
    tool_transpose: "ट्रांसपोज (Ctrl + शिफ्ट + टी) 1।",
    label_width: "चौड़ाई",
    label_height: "ऊंचाई",
    label_frames: "फ्रेम की संख्या",
    label_animation: "एनीमेशन शैली",
    label_background_color: "पृष्ठभूमि रंग",
    label_interval: "अंतराल",
    tool_anim_config: "एनीमेशन विन्यास",
    label_new_width: "नई चौड़ाई",
    label_new_height: "न्यू हाइट",
    label_apply: "लागू",
    label_colors: "रंग",
    label_size: "माप",
    label_tolerance: "सहनशीलता",
    val_horizontal: "क्षैतिज",
    val_vertical: "खड़ा",
    val_sequence: "क्रम",
    val_bounce: "उछलब",
    val_random: "अनियमित",
    val_solid: "ठोस",
    val_clear: "साफ",
    action_add_sheet: "नया शीट",
    action_import: "आयात",
    action_export: "निर्यात",
    action_sort_projects: "प्रकार",
    sort_date_old: "सबसँ पुरान पहिल",
    sort_date_new: "नवीनतम प्रथम",
    sort_name_az: "नाम (ए-जेड) २.",
    sort_name_za: "नाम (जेड-ए) २.",
    action_new_sprite: "न्यू स्प्राइट",
    action_new_project: "नया परियोजना",
    modal_save_all_title: "सब परिवर्तन सहेजें",
    modal_save_all_desc: "सहेजबाक लेल संपत्ति चुनू:",
    modal_save_selected: "चयनित सहेजें",
    action_saved: "सहेजल गेल",
    modal_create_sprite_title: "नया स्प्राइट बनाइए",
    modal_create_project_title: "नया प्रोजेक्ट बनाइए",
    modal_add_sheet_title: "नया शीट जोड़ू",
    modal_rename_sheet_title: "शीट के नाम बदलें",
    modal_rename_sprite_title: "स्प्राइट के नाम बदलें",
    modal_delete_sprite_title: "स्प्राइट मेटाउ",
    modal_delete_project_title: "परियोजना मेटाउ",
    modal_delete_sheet_title: "शीट मेटाउ",
    placeholder_sprite_name: "नाम",
    placeholder_project_name: "नाम",
    placeholder_sheet_name: "नाम",
    placeholder_new_name: "नया नाम",
    action_create: "बनाउ",
    action_add: "जोड़ू",
    action_rename: "नाम बदलें",
    action_duplicate: "डुप्लिकेट",
    action_delete: "हटानाइ",
    action_cancel: "रद्द",
    confirm_delete_sprite: "की अहाँ निश्चित छी जे अहाँ एहि स्प्राइट केँ मेटाबए चाहैत छी?",
    confirm_delete_project: "की अहाँ निश्चित छी जे अहाँ एहि प्रोजेक्ट केँ मेटाबए चाहैत छी? सभ स्प्राइट हटा देल जाएत।",
    confirm_delete_sheet: "की अहाँ निश्चित छी जे अहाँ एहि शीट केँ मेटाबए चाहैत छी?",
    err_select_sprite: "कृपया पहिने एकटा स्प्राइट चुनू.",
    err_select_project: "कृपया पहिने कोनो प्रोजेक्ट चुनू।",
    err_name_empty: "नाम खाली नहि भ' सकैत अछि।",
    err_sprite_exists: "ओहि नामक स्प्राइट पहिनेसँ मौजूद अछि ।",
    err_project_exists: "ओहि नामक प्रोजेक्ट पहिने सँ मौजूद अछि।",
    err_no_content: "सहेजबाक लेल कोनो सामग्री नहि।",
    err_no_changes: "सहेजबाक लेल कोनो परिवर्तन नहि।",
    err_delete_last_sheet: "अंतिम शीट मेटा नहि सकैत अछि.",
    err_extract_frames: "कोनो फ्रेम निकालि नहि सकल।",
    err_indexeddb: "स्थानीय रूपसँ सहेजबामे विफल। अहाँक ब्राउज़र IndexedDB क समर्थन नहि क' सकैत अछि.",
    msg_upload_success: "अपलोड सफल: {0}",
    msg_upload_failed: "अपलोड विफल: {0}",
    msg_save_success: "बचाउ सफल।",
    msg_saving: "बचत क रहल छी...",
    msg_multi_save_result: "सहेजल गेल {0} संपत्ति। {1} असफलता।",
    menu_title: "मेनू",
    menu_save: "बचाउ",
    menu_save_all: "सब बचाउ",
    menu_support: "समर्थन से संपर्क करें",
    label_local_storage: "स्थानीय भंडारण",
    label_sign_in: "साइन इन करू",
    modal_export_title: "निर्यात स्प्राइट",
    label_filename: "फाइल नाम",
    label_format: "प्रारूप",
    action_export_confirm: "निर्यात",
};

export default translations;
